export interface SingleCustomerProduct {
	group: string;
	name: string;
	productId: string;
	startDate: string;
	legacyProductId: string;
}

const model: types.models.InputModel = {
	group: 'group',
	name: 'name',
	productId: 'productId',
	startDate: 'startDate',
	legacyProductId: 'legacyProductId',
};

export default model;
